module.exports = __webpack_public_path__ + "img/m16luomu.prt.4976eebe.jpg";